import { useQuery } from '@tanstack/react-query';
import { ErrorHandler } from '@helper/errorHandler';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { APICONFIG } from '@config/api.config';
import { IFccEnroll } from '.';

export const useFccEnrollUserQuery = (id: number | null | undefined): IQueryResponse<IFccEnroll> => {
	const fetchFccEnrollUserData = async (): Promise<IFccEnroll> => {
		try {
			return await APIService.getData<IFccEnroll>(`${APICONFIG.FCC_ENROLL}${id}`);
		} catch (error) {
			ErrorHandler(error);
			throw error;
		}
	};

	const { data, error, isLoading, isPending, isFetching, refetch } = useQuery({
		queryKey: ['fccEnroll'],
		queryFn: fetchFccEnrollUserData,
		refetchOnWindowFocus: false,
		enabled: false,
		gcTime: 0,
		staleTime: 0,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
		refetch,
	};
};
